// eslint-disable-next-line import/prefer-default-export
export const getSearchableDate = (customDates, search) => {
  const results = customDates.filter((date) => {
    if (search === "") return customDates;
    return date.name.toLowerCase().includes(search.trim().toLowerCase());
  });
  return results;
};
